import strings from '../strings';
import { NOTIFICATION_TYPES } from '../constants/uiParams';

class RootStore {
  constructor(uiStore, ratingStore, geoStore, featureStore) {
    this.uiStore = uiStore;
    this.ratingStore = ratingStore;
    this.geoStore = geoStore;
    this.featureStore = featureStore;
  }

  init = async () => {
    const { uiContext } = this.uiStore;
    const { geoContext } = this.geoStore;
    this.uiStore.clearNotificationsList();

    const requestObject = {
      ...uiContext,
      ...geoContext,
    };

    const ratingResponse = await this.ratingStore.fetch(requestObject);
    const responseStatus = ratingResponse.response && ratingResponse.response.status;
    if (responseStatus >= 500 && responseStatus < 600) {
      // delay = 0 - нотификация сама не закроется, может быть закрыто вручную
      this.uiStore.addNotification({ content: strings.getRatingError, type: NOTIFICATION_TYPES.ERROR, delay: 0 });
    }

    const { setSelectedSuggestionFromQs } = this.geoStore;
    setSelectedSuggestionFromQs(ratingResponse);
  }

  reload = async () => {
    this.uiStore.resetSkipTake();
    await this.init();
  }
}

export default RootStore;
